import {ReduceStore} from 'flux/utils';
import AppDispatcher from '../AppDispatcher';

class LogStore extends ReduceStore {
    constructor() {
        super(AppDispatcher);
    }

    getInitialState() {
        return null;
    }

    reduce(state, action) {
        console.log(JSON.stringify(action));
        return null;
    }
}

export default new LogStore();



// WEBPACK FOOTER //
// src/stores/LogStore.js